<template>
  <div>
    <el-dialog
      :visible.sync="diffVisible"
      title=" "
      width="60%"
      :modal-append-to-body="false"
      append-to-body
      @close="handleClose"
    >
      <div class="diff-container">
        <div class="diff-left">
          <div class="title">
            <span>修改前</span>
          </div>
          <div class="diff-left-content">
            <div class="container">
              <div class="left">left</div>
              <div class="right">right</div>
            </div>
          </div>
        </div>
        <div class="diff-right">
          <div class="title">
            <span>修改后</span>
          </div>
          <div class="diff-right-content">
            <div class="container">
              <div class="left">left</div>
              <div class="right">right</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 关闭按钮 -->
      <!-- <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handleClose"
          >关闭</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import Message from "@/components/Message";
export default {
  name: "WebSassMemberRightLog",
  watch: {
    logDialogVisible(newVal) {
      if (newVal) {
        console.log("拿到的id", this.id);
        /** 修正分页参数 */
        this.searchParams.subjectId = this.id;
        /** 获取操作日志 */
        this.getLogList();
      }
    },
  },
  data() {
    return {
      diffVisible: false,
      list: [],
      /** 分页参数 */
      searchParams: {
        current: 1,
        size: 10,
        total: 50,
        /** 记录id */
        subjectId: "",
      },
    };
  },
  methods: {
    show() {
      this.diffVisible = true;
    },
    hide() {
      this.diffVisible = false;
    },
    /** 查询操作日志的接口 */
    async getLogList() {
      console.log("分页参数", this.searchParams);
      // console.log('获取操作日志的响应', data)
      // this.list = data.data.records
      // this.searchParams.total = data.data.total
    },

    /** 对话框关闭 */
    handleClose() {
      this.hide();
      /** 关闭之后清空数据 */
      this.list = [];
    },
    //^ ^--------------分页相关 start-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      this.getLogList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      this.getLogList();
    },
    //^ ^--------------分页相关 end-------------^ ^
  },
};
</script>

<style lang="scss" scoped>
.diff-container {
  padding: 0px 20px;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .diff-left {
    width: 100%;
    margin-right: 5%;
    .diff-left-content {
      width: 95%;
      height: 500px;
      overflow-y: auto;
      background-color: #f4f4f4;
      border-radius: 10px;
      padding: 20px 0 0 20px;
      .container {
        display: flex;
        .left {
          width: 35%;
        }
        .right {
          width: 65%;
        }
      }
    }
  }
  .diff-right {
    width: 100%;
    margin-left: 5%;
    .diff-right-content {
      width: 95%;
      height: 500px;
      overflow-y: auto;
      background-color: #f4f4f4;
      border-radius: 10px;
      margin-right: 40px;
      padding: 20px 0 0 20px;
      .container {
        display: flex;
        .left {
          width: 35%;
        }
        .right {
          width: 65%;
        }
      }
    }
  }
}
</style>
